// extracted by mini-css-extract-plugin
module.exports = {"articlesContainer":"SelectedArticlesList_articlesContainer__3c1AQ"};